export default __webpack_public_path__ + "static/media/2.2a9e0972.webp";